import { InlineHelp } from "@/components/common/InlineHelp";
import type { IntEvent } from "./opsPaperworkTypes";

export function OpsPaperworkTimelineTab(props: { selectedId: string | null; events: IntEvent[] }) {
  return (
    <div className="space-y-2">
      <InlineHelp label="About the timeline">
        {props.selectedId
          ? "Inbound events linked to this deal."
          : "Latest inbound events for this org (IdeaRoom, inventory host). Open a deal to filter."}{" "}
        IdeaRoom fires store the original JSON even before a deal exists. Full payloads live on
        ops_integration_events; this list is the receipt log.
      </InlineHelp>
      <ul className="text-sm space-y-2">
        {props.events.map((ev) => (
          <li key={ev.id} className="border border-gray-100 rounded-lg px-2 py-1">
            <span className="font-mono text-xs">{ev.source || "event"}</span>
            {" · "}
            <span className="font-mono text-xs">{ev.event_type}</span> · {ev.processing_status} ·{" "}
            {new Date(ev.created_at).toLocaleString()}
          </li>
        ))}
        {props.events.length === 0 ? (
          <li className="text-gray-500">
            {props.selectedId ? "No integration events yet for this deal." : "No inbound events yet."}
          </li>
        ) : null}
      </ul>
    </div>
  );
}
